import gql from 'graphql-tag'

export const SUBSCRIBE_ALL_APPLICATIONS = gql`
subscription {
 Applications{      id
      stageId
      partnerType
      name
      userName
      address
      mobile
      email
      PartnerType { name }
      Stage { name }
      User {name}
      updatedOn
 }
}
`
export const SUBSCRIBE_APPLICATION_HISTORY= gql`
subscription ApplicationHistory($applicationId: uuid!){
 ApplicationHistory(where: {applicationId: {_eq: $applicationId}},order_by: {createdOn: desc}){      
      id
      applicationId
      oldObject
      newObject
      difference
      eventType
      createdByUserName
      createdOn
 }
}
`
